module.exports = __webpack_public_path__ + "img/logo.98a050f6.svg";